var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-truck"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-analysis-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#631386"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.58,28.077c0,0.446 -0.362,0.808 -0.808,0.808l-19.384,-0c-0.446,-0 -0.808,-0.362 -0.808,-0.808l0,-16.154c0,-0.446 0.362,-0.808 0.808,-0.808c0.446,0 0.807,0.362 0.807,0.808l0,10.973l5.083,-5.083c0.147,-0.146 0.349,-0.236 0.572,-0.236c0.223,-0 0.425,0.09 0.571,0.236l2.659,2.66l6.127,-6.127l-2.088,0c-0.446,0 -0.808,-0.361 -0.808,-0.808c0,-0.446 0.362,-0.807 0.808,-0.807l4.038,-0c0.027,-0 0.053,0.001 0.08,0.004c0.012,0.001 0.023,0.003 0.035,0.005c0.015,0.002 0.029,0.004 0.043,0.006c0.013,0.003 0.026,0.007 0.04,0.01c0.012,0.003 0.024,0.006 0.037,0.01c0.013,0.004 0.025,0.008 0.038,0.013c0.012,0.004 0.024,0.008 0.036,0.013c0.012,0.005 0.023,0.011 0.034,0.016c0.013,0.006 0.026,0.012 0.038,0.018c0.011,0.006 0.021,0.012 0.031,0.018c0.012,0.008 0.025,0.015 0.037,0.023c0.011,0.007 0.021,0.015 0.032,0.023c0.01,0.008 0.021,0.016 0.031,0.024c0.017,0.014 0.033,0.028 0.048,0.043c0.004,0.004 0.008,0.007 0.011,0.01c0.004,0.004 0.007,0.008 0.011,0.012c0.015,0.015 0.029,0.031 0.043,0.047c0.008,0.011 0.016,0.022 0.024,0.033c0.008,0.01 0.016,0.02 0.023,0.031c0.008,0.012 0.015,0.025 0.023,0.038c0.006,0.01 0.012,0.019 0.017,0.029c0.007,0.013 0.013,0.027 0.019,0.04c0.005,0.011 0.011,0.021 0.015,0.032c0.006,0.013 0.01,0.026 0.015,0.039c0.004,0.012 0.008,0.023 0.012,0.036c0.004,0.013 0.007,0.026 0.01,0.039c0.003,0.012 0.007,0.025 0.009,0.037c0.003,0.016 0.005,0.031 0.007,0.047c0.002,0.01 0.004,0.021 0.005,0.032c0.003,0.026 0.004,0.053 0.004,0.08l0,4.038c0,0.446 -0.362,0.808 -0.808,0.808c-0.446,-0 -0.807,-0.362 -0.807,-0.808l-0,-2.088l-6.698,6.698c-0.147,0.146 -0.349,0.236 -0.572,0.236c-0.223,0 -0.425,-0.09 -0.571,-0.236l-2.659,-2.66l-5.654,5.654l-0,2.088l18.576,0c0.446,0 0.808,0.362 0.808,0.808l0,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRAnalytics);
export default __webpack_public_path__ + "static/media/iconR-analytics.6f7fc7b805f0e0a10ca2365a18208b40.svg";
export { ForwardRef as ReactComponent };